import { genComponentEl } from '@/utils/utils';
import Component from './index.vue';
import SampleComponent from './sample-dialog.vue';

/**
 * 显示自定义库窗口
 * @param {Object} data
 */
export function showCustomLibaryDialog(data) {
  genComponentEl(Component, data);
}

/**
 * 显示采样窗口
 * @param {Object} data
 */
export function showCollSampleDialog(data) {
  genComponentEl(SampleComponent, data);
}
